<template>
    <div>
        <div class="product_menu">
            <dl class="pageCenter" id="product_menu">
                <dt><a href="#page1" title="唐麦耳机S1">Tangmai S1</a></dt>
                <dd data-menuanchor="page2"><a href="#page2">概览</a></dd>
                <dd data-menuanchor="page3"><a href="#page3">设计</a></dd>
                <dd data-menuanchor="page4"><a href="#page4">音质</a></dd>
                <dd data-menuanchor="page5"><a href="#page5">性能</a></dd>
                <dd data-menuanchor="page6"><a href="#page6">体验</a></dd>
                <dd data-menuanchor="page7"><a href="#page7">品质</a></dd>
                <dd data-menuanchor="page8"><a href="#page8">参数</a></dd>
                <!--<dd><a href="images_s1.html#page2">图集</a></dd>-->
            </dl>
        </div>
        <div id="product" style="z-index:1;" v-if="platform == 1">
            <!-- 头部 -->
            <div class="section header active fp-auto-height">
                <v-header></v-header>

                <div class="product_menu2">
                    <div class="product_menu2">
                        <dl class="pageCenter">
                            <dd data-menuanchor="page2"><a href="#page2">概览</a></dd> 
                            <dd data-menuanchor="page3"><a href="#page3">设计</a></dd>
                            <dd data-menuanchor="page4"><a href="#page4">音质</a></dd>
                            <dd data-menuanchor="page5"><a href="#page5">性能</a></dd>
                            <dd data-menuanchor="page6"><a href="#page6">体验</a></dd>
                            <dd data-menuanchor="page7"><a href="#page7">品质</a></dd>
                            <dd data-menuanchor="page8"><a href="#page8">参数</a></dd>
                            <!--<dd><a href="images_s1.html#page2">图集</a></dd>-->
                        </dl>
                    </div>
                </div>
            </div>

            <div class="section product_li" style=" background:url(http://wx2.sinaimg.cn/large/0067mezugy1fw3gf4nzhvj31hc0jgtad.jpg) center; background-size:auto 100%;">
            <p class="p1" style="top: 50%; margin-top: -121px;"><img src="../../assets/img/s1/1.png" style="margin-left: 600px;" /></p>
        </div>
        <div class="section product_li" style=" background:url(http://wx4.sinaimg.cn/large/0067mezugy1fw3gf53qbcj31hc0jgdgm.jpg) center; background-size:auto 100%;">
            <p class="p1" style="top: 50%; margin-top: -121px;"><img src="../../assets/img/s1/2.png" style="margin-left: -600px;" /></p>
        </div>
        <div class="section product_li" style=" background:url(http://wx2.sinaimg.cn/large/0067mezugy1fw3gf5i7wmj31hc0jgack.jpg) center; background-size:auto 100%;">
            <p class="p1" style="top: 50%; margin-top: -121px;"><img src="../../assets/img/s1/3.png" style="margin-left: 600px;" /></p>
        </div>
        <div class="section product_li" style=" background:url(http://wx4.sinaimg.cn/large/0067mezugy1fw3gf63ewnj31hc0jg400.jpg) center; background-size:auto 100%;">
            <p class="p1" style="top: 50%; margin-top: -121px;"><img src="../../assets/img/s1/4.png" style="margin-left: -600px;" /></p>
        </div>
        <div class="section product_li" style=" background:url(http://wx1.sinaimg.cn/large/0067mezugy1fw3gf77ruij31hc0jg77n.jpg) center; background-size:auto 100%;">
            <p class="p1" style="top: 10%"><img src="../../assets/img/s1/5.png" /></p>
        </div>
        <div class="section product_li" style=" background:url(http://wx2.sinaimg.cn/large/0067mezugy1fw3gf7l32cj31hc0jgtar.jpg) center; background-size:auto 100%;">
            <p class="p1" style="top: 10%"><img src="../../assets/img/s1/6.png" /></p>
        </div>
        <div class="section product_li">
            <div class="pageCenter">
            	<p style=" top:20%; text-align:left; width:100%;"><img src="../../assets/img/s1/7.png" /></p>
				
            </div>
        </div>

            <!-- 尾部 -->
            <div class="section fp-auto-height fp-section">
                <v-footer></v-footer>
            </div>
            
        </div>

        <div id="mobile" v-else>
            <!--手机端头部-->
            <v-header></v-header>
            <div class="mobile_pageMain">
                <div class="tools">
                    <span class="span1">产品</span>
                    <span class="span2">唐麦 S1</span>
                </div>
                <img class="productImg" style="margin-top:40px;" src="http://wx1.sinaimg.cn/large/0067mezugy1fw3bst4y4ej30k00vigmh.jpg" />
                <img class="productImg" src="http://wx2.sinaimg.cn/large/0067mezugy1fw3bstju9aj30k00vigmb.jpg" />
                <img class="productImg" src="http://wx2.sinaimg.cn/large/0067mezugy1g6nt192grdj30k00vidl8.jpg" />
                <img class="productImg" src="http://wx1.sinaimg.cn/large/0067mezugy1fw3bsv88plj30k00vigmz.jpg" />
                <img class="productImg" src="http://wx1.sinaimg.cn/large/0067mezugy1fw3bsurgxaj30k00vi0tx.jpg" />
                <img class="productImg" src="http://wx2.sinaimg.cn/large/0067mezugy1fw3bsvu6fwj30k00vigmu.jpg" />
                <img class="productImg" src="http://wx4.sinaimg.cn/large/0067mezugy1fw3bswfopfj30k00viab1.jpg" />
            </div>
            <v-footer></v-footer>
        </div>
        <!-- 回到顶部 -->
        <a href="#page1"><goto-top></goto-top></a>
    </div>
</template>
<script>
//引入fullpage
import "../../assets/libs/fullpage/jquery.fullPage.css"
import "../../assets/libs/fullpage/jquery.fullPage.min.js"
import "../../assets/css/style.css"
    export default{
        data(){
            return {
                platform: 1   //1 pc端   2 mobile端
            }
        },
        mounted(){
            if($(window).width() > 786){
                this.platform = 1;
                var $mlNav = $('.product_menu');
                $('#product').fullpage({
                    verticalCentered: !1,
                    navigation: !0,
                    anchors: ['page1', 'page2', 'page3', 'page4', 'page5', 'page6', 'page7', 'page8', 'page9', 'page10', 'page11'],
                    menu: '#product_menu',
                    onLeave: function(index, nextIndex, direction){
                        if(index == 2 && direction == 'up'){
                            $mlNav.animate({
                                top: -100
                            }, 0);
                        } else if(index == 1 && direction == 'down') {
                            $mlNav.animate({
                                top: 0
                            }, 500);
                            $(".headmenu_two").hide();
                        }
                        if(nextIndex == 1){
                            $mlNav.animate({
                                top: -100
                            }, 0);
                        }
                        if(nextIndex == 11){
                            $mlNav.hide();
                        }else{
                            $mlNav.show();
                        }
                    },
                    afterLoad: function(anchorLink, index){
                        //$(".product_li").css("height", $("#product").height());
                        $(".product_menu dt a").css("color","#9e9e9f");
                        $(".product_menu dd a").css("color","#9e9e9f");
                        $(".product_menu dd.active a").css("color","#000000");
                        $(".product_menu dt a").mouseover(function(){
                            $(this).css("color","#000000");
                        });
                        $(".product_menu dd a").mouseover(function(){
                            $(this).css("color","#000000");
                        });
                        $(".product_menu dt a").mouseleave(function(){
                            $(this).css("color","#9e9e9f");
                        });
                        $(".product_menu dd a").mouseleave(function(){
                            $(this).css("color","#9e9e9f");
                        });
                        
                        /*回到顶部*/
                        if(index == 1 || index == 2){
                            $(".gotoTop").hide();
                        }else{
                            $(".gotoTop").show();
                        }
                    }
                })
            }else{
                this.platform = 2;
            }
        },
        destroyed(){
            var html = document.querySelector("html");
            var width = html.getBoundingClientRect().width;
            //设置 1rem = width/16
            if(width >= 768){
                //去除fullpage插件设置的100%高度和隐藏溢出
                $("html, body").removeAttr("style");
                $("html, body").removeAttr("class");
            }
        }
    }
</script>
<style scoped>
@media (min-width: 768px){
    .header-wrap{
        position: relative !important;
    }
}
    

    
</style>


// WEBPACK FOOTER //
// src/pages/products/s1.vue